import React, { createContext, useContext, useEffect, useState } from "react";
import api, { setToken, formatApiError } from "@/lib/api";
import { applyZoom } from "@/lib/zoom";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("gv_token")) refresh();
    else { setUser(false); setLoading(false); }
  }, []);

  // Follow the player's saved interface zoom across devices once their account loads.
  useEffect(() => {
    if (user && typeof user === "object" && user.zoom_pref) applyZoom(user.zoom_pref);
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setToken(data.token);
    setUser(data);
    return data;
  };

  const enroll = async (payload) => {
    const { data } = await api.post("/school/enroll", payload);
    setToken(data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setToken(null);
    setUser(false);
  };

  const patchUser = (partial) => setUser((u) => (u ? { ...u, ...partial } : u));

  return (
    <AuthContext.Provider value={{ user, loading, login, register, enroll, logout, refresh, patchUser, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
